import React, { FormHTMLAttributes } from "react";
import { useForm } from "react-hook-form";

interface SmartFormProps extends FormHTMLAttributes<HTMLFormElement> {
    defaultValues?: any;
    children: JSX.Element | JSX.Element[];
    onSubmit: any;
}

const SmartForm = (props: SmartFormProps): JSX.Element => {
    const methods = useForm({ defaultValues: props.defaultValues });
    const { handleSubmit } = methods;

    return (
        <form onSubmit={handleSubmit(props.onSubmit)}>{props.children}</form>
    );
};

export default SmartForm;
